import Layout from '@/layout'

const route = {
  path: '/adMonitor',
  component: Layout,
  redirect: '/adMonitor/index',
  alwaysShow: true, // will always show the root menu
  name: 'CrowdManagement',
  meta: {
    title: '广告监控',
    icon: 'AdMonitor',
    roles: ['ad.monitor']
  },
  children: [
    // 广告统计
    {
      path: '/adMonitor/adCount/index',
      component: () => import('@/views/adMonitor/adCount/index.vue'),
      name: 'adCount',
      meta: {
        title: '广告统计',
        icon: 'component',
        roles: ['ad.ad_num_list']
      }
    },
    {
      path: '/adMonitor/materialCount/index',
      component: () => import('@/views/adMonitor/materialCount/index.vue'),
      name: 'materialCount',
      meta: {
        title: '素材统计',
        icon: 'component',
        roles: ['ad.material_statistics']
      }
    },
    {
      path: '/adMonitor/releaseGroupCount/index',
      component: () => import('@/views/adMonitor/releaseGroupCount/index.vue'),
      name: 'releaseGroupCount',
      meta: {
        title: '投放组统计',
        icon: 'component',
        roles: ['ad.leader_statistics']
      }
    },
    {
      path: '/adMonitor/releaserCount/index',
      component: () => import('@/views/adMonitor/releaserCount/index.vue'),
      name: 'releaserCount',
      meta: {
        title: '投手统计',
        icon: 'component',
        roles: ['ad.pitcher_statistics']
      }
    }
  ]
}

export default route
